export default "__VITE_ASSET__CG6No94n__"